import { render, staticRenderFns } from "./NotizModal.vue?vue&type=template&id=41491ad0&scoped=true"
import script from "./NotizModal.vue?vue&type=script&lang=js"
export * from "./NotizModal.vue?vue&type=script&lang=js"
import style0 from "./NotizModal.vue?vue&type=style&index=0&id=41491ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41491ad0",
  null
  
)

export default component.exports